import { SelectItemProps } from 'core-system/Dropdown'

export const COMMUTER_MENU_IDS = {
  ARCHIVE: '0',
  REACTIVATE: '1',
  CHANGE_WORKSITE: '2',
  SEND_INVITE: '3',
  EDIT_ALLOCATION: '4',
  GIVE_OTR: '5',
  MANAGE_TAGS: '6',
  REQUEST_TRANSIT_CARD: '7',
}

interface CommuterDetailsMenuParams {
  isArchived: boolean
  isFinchEmp: boolean
  hasRegistered: boolean
  hasUpcomingAllocation: boolean
  hasOtr: boolean
  canRequestTransitCard: boolean
  hasNoAvailableTransitAgencies?: boolean
  commuterWorksiteArchived?: boolean
  worksiteLabel: string
  employee?: { id: string }
  activeTab: number
}

export const getCommuterDetailsMenuItems = (
  params: CommuterDetailsMenuParams
): SelectItemProps[] => {
  const {
    isArchived,
    isFinchEmp,
    hasRegistered,
    hasUpcomingAllocation,
    hasOtr,
    canRequestTransitCard,
    hasNoAvailableTransitAgencies = false,
    commuterWorksiteArchived,
    worksiteLabel,
    employee,
    activeTab,
  } = params

  if (isArchived) {
    return [
      {
        id: COMMUTER_MENU_IDS.REACTIVATE,
        text: 'Re-activate Commuter',
        disabled: commuterWorksiteArchived,
        employee,
        productLabel: null,
      },
    ]
  }

  const items: SelectItemProps[] = [
    {
      id: COMMUTER_MENU_IDS.ARCHIVE,
      text: 'Archive Commuter',
      disabled: isFinchEmp || activeTab === -1,
    },
    {
      id: COMMUTER_MENU_IDS.CHANGE_WORKSITE,
      text: worksiteLabel,
      disabled: isFinchEmp || activeTab === -2,
    },
    {
      id: COMMUTER_MENU_IDS.SEND_INVITE,
      text: 'Send Invite',
      disabled: hasRegistered || activeTab === -3,
    },
  ]

  if (hasUpcomingAllocation) {
    items.push({
      id: COMMUTER_MENU_IDS.EDIT_ALLOCATION,
      text: 'Edit Allocation',
      disabled: activeTab === -4,
    })
  }

  if (hasOtr) {
    items.push({
      id: COMMUTER_MENU_IDS.GIVE_OTR,
      text: 'Give One Time Reward',
      disabled: activeTab === -5,
    })
  }

  if (canRequestTransitCard) {
    items.push({
      id: COMMUTER_MENU_IDS.REQUEST_TRANSIT_CARD,
      text: 'Request Transit Card',
      disabled: hasNoAvailableTransitAgencies,
    })
  }

  items.push({
    id: COMMUTER_MENU_IDS.MANAGE_TAGS,
    text: 'Manage Tags',
    disabled: activeTab === -6,
  })

  return items
}
